export const creditMemoListColumns = [
    // {
    //     Header: 'Credit Memo #',
    //     accessor: 'creditMemoNumber',
    //     width: 150,
    //     enableFilter: true,
    //     type: 'text',
    // },
    {
        Header: 'Original Invoice',
        accessor: 'originalInvoice.invoiceNumber',
        width: 150,
        enableFilter: true,
        type: 'text',
        Cell: ({ row }) => {
            const invoice = row.original.originalInvoice;
            return invoice ? invoice.invoiceNumber : 'N/A';
        }
    },
    {
        Header: 'Credit Date',
        accessor: 'creditDate',
        enableFilter: true,
        type: 'date',
        width: 120,
        Cell: ({ value }) => {
            if (!value) return 'N/A';
            return new Date(value).toLocaleDateString();
        }
    },
    {
        Header: 'Credit Amount',
        accessor: 'creditAmount',
        enableFilter: true,
        type: 'number',
        width: 130,
        Cell: ({ value }) => {
            return `$${parseFloat(value || 0).toFixed(2)}`;
        }
    },
    {
        Header: 'Remaining',
        accessor: 'remainingAmount',
        enableFilter: true,
        type: 'number',
        width: 130,
        Cell: ({ value }) => {
            const amount = parseFloat(value || 0);
            return (
                <span style={{ 
                    color: amount > 0 ? '#2e7d32' : '#666',
                    fontWeight: amount > 0 ? 'bold' : 'normal'
                }}>
                    ${amount.toFixed(2)}
                </span>
            );
        }
    },
    // {
    //     Header: 'Location',
    //     accessor: 'location.name',
    //     enableFilter: true,
    //     type: 'text',
    //     width: 150,
    //     Cell: ({ row }) => {
    //         const location = row.original.location;
    //         return location ? location.name : 'N/A';
    //     }
    // },
    // {
    //     Header: 'Reason',
    //     accessor: 'reason',
    //     enableFilter: false,
    //     width: 250,
    //     Cell: ({ value }) => {
    //         if (!value) return 'N/A';
    //         return value.length > 50 ? `${value.substring(0, 50)}...` : value;
    //     }
    // },
    {
        Header: 'Authorized By',
        accessor: 'authorizedBy',
        enableFilter: true,
        type: 'text',
        width: 150,
        Cell: ({ value }) => value || 'N/A'
    },
    {
        Header: 'Applied Date',
        accessor: 'appliedDate',
        enableFilter: true,
        type: 'date',
        width: 120,
        Cell: ({ value }) => {
            if (!value) return '-';
            return new Date(value).toLocaleDateString();
        }
    },
{
        Header: 'Status',
        accessor: 'status',
        width: 120,
        Cell: ({ value }) => {
            const statusColors = {
                pending: '#ff9800',
                approved: '#4caf50',
                applied: '#2196f3',
                cancelled: '#f44336'
            };
            const statusLabels = {
                pending: 'Pending',
                approved: 'Approved',
                applied: 'Applied',
                cancelled: 'Cancelled'
            };
            const bgColor = statusColors[value] || '#999';
            const label = statusLabels[value] || value;
            
            return (
                <span style={{
                    backgroundColor: bgColor,
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                    display: 'inline-block'
                }}>
                    {label}
                </span>
            );
        }
    },    
];
